import { Center, Container, Loader, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import type { Offer } from '@/api/generated/models';
import type { StatusHistoryEntry } from '@/features/history/statusHistoryTypes';
import { OfferStatus } from '@/api/generated/models/offerStatus';
import { useGetOffer, useGetOfferHistory } from '@/api/generated/offers/offers';
import { BackButton, ContentCard } from '@/components/common';
import { StatusHistoryTable } from '@/features/history/components/StatusHistoryTable';
import { statusConfig } from '@/features/offers/offerDisplay';

export const OfferHistoryPage = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const { data: offerData, isLoading: isLoadingOffer } = useGetOffer(id ?? '', {
    query: { enabled: !!id }
  });
  const offer = offerData as Offer | undefined;
  const { data: historyData, isLoading: isLoadingHistory } = useGetOfferHistory(id ?? '', {
    query: { enabled: !!id }
  });
  const entries = (historyData as StatusHistoryEntry[] | undefined) ?? [];

  const resolveStatus = (raw: string) => {
    const config = statusConfig[raw as OfferStatus];
    return config
      ? { label: t(config.labelKey), bg: config.bg, fg: config.fg }
      : { label: raw, bg: 'var(--color-bg-surface-2)', fg: 'var(--color-text-secondary)' };
  };

  if (isLoadingOffer || isLoadingHistory || !offer) {
    return (
      <Container size="lg" px={0}>
        <Center py={80}>
          <Loader size="sm" />
        </Center>
      </Container>
    );
  }

  return (
    <Container size="lg" px={0}>
      <Stack gap={24}>
        <BackButton to={`/offers/${id}`} />
        <Text fz={14} fw={600} style={{ color: 'var(--color-text-secondary)' }}>
          {t('offerDetail.title', { number: offer.offerNumber ?? offer.referenceId })}
        </Text>
        <ContentCard>
          <div style={{ padding: 20 }}>
            <StatusHistoryTable entries={entries} resolveStatus={resolveStatus} />
          </div>
        </ContentCard>
      </Stack>
    </Container>
  );
};
